export const NEW_RISK_ENUM = {
	'001': 'Ⅰ类',
	'002': 'Ⅱ类',
	'003': 'Ⅲ类',
};
